import PropTypes from 'prop-types'

export const mapShape = PropTypes.shape({
  size: PropTypes.number.isRequired,
  clear: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  entries: PropTypes.func.isRequired,
  forEach: PropTypes.func.isRequired,
  get: PropTypes.func.isRequired,
  has: PropTypes.func.isRequired,
  keys: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  values: PropTypes.func.isRequired,
})

export const setShape = PropTypes.shape({
  size: PropTypes.number.isRequired,
  add: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  entries: PropTypes.func.isRequired,
  forEach: PropTypes.func.isRequired,
  has: PropTypes.func.isRequired,
  keys: PropTypes.func.isRequired,
  values: PropTypes.func.isRequired,
})

export const subscriptionSkuShape = PropTypes.shape({
  sku: PropTypes.string.isRequired,
  qty: PropTypes.number.isRequired,
})

export const invitationShape = PropTypes.shape({
  email: PropTypes.string.isRequired,
  invitationStatus: PropTypes.oneOf(['ACT', 'INV', 'CAN', 'Pending'])
    .isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
  sent: PropTypes.string.isRequired,
  userId: PropTypes.number,
})

export const schoolShape = PropTypes.shape({
  address1: PropTypes.string,
  address2: PropTypes.string,
  billAddress: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  customerId: PropTypes.string,
  description: PropTypes.string,
  mdrpid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  state: PropTypes.string,
  stateCode: PropTypes.string,
  zipCode: PropTypes.string,
})

export const skuShape = PropTypes.shape({
  description: PropTypes.string,
  isActive: PropTypes.bool,
  skuValue: PropTypes.string,
})

export const productShape = PropTypes.shape({
  description: PropTypes.string,
  duration: PropTypes.number,
  id: PropTypes.number,
  programCodes: PropTypes.oneOf([
    'ADL',
    'BPU',
    'CPU',
    'HSP',
    'K5P',
    'MSP',
    'OST',
    'SSP',
  ]),
  sku: PropTypes.shape(skuShape),
  skuCode: PropTypes.string,
  type: PropTypes.string,
})

export const siteShape = PropTypes.shape({
  address: PropTypes.object,
  createdBy: PropTypes.string,
  createdDate: PropTypes.string,
  id: PropTypes.number,
  isRostered: PropTypes.bool,
  modifiedBy: PropTypes.string,
  modifiedDate: PropTypes.string,
  name: PropTypes.string,
  netsuiteCustomer: PropTypes.object,
  netsuiteCustomerId: PropTypes.number,
  organization: PropTypes.object,
  organizationId: PropTypes.number.isRequired,
})

export const licenseShape = PropTypes.shape({
  admins: PropTypes.arrayOf({
    email: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }),
  cancelledDate: PropTypes.string,
  expirationDate: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  isExpired: PropTypes.bool,
  modifiedBy: PropTypes.string,
  modifiedDate: PropTypes.string,
  nsLicenseId: PropTypes.number,
  nsSubscriptionId: PropTypes.string,
  originationDate: PropTypes.string,
  previousSubscriptionId: PropTypes.number,
  product: PropTypes.oneOfType(PropTypes.shape(productShape)),
  setupAdminEmail: PropTypes.string,
  site: PropTypes.oneOfType(PropTypes.shape(siteShape)),
  siteId: PropTypes.number,
  siteName: PropTypes.string,
  startDate: PropTypes.string.isRequired,
  subscriptionId: PropTypes.number.isRequired,
})

export const subscriptionShape = PropTypes.shape({
  assignedSkusNotInSubscription: PropTypes.bool.isRequired,
  canceledLicenses: PropTypes.arrayOf(licenseShape),
  expirationDate: PropTypes.string.isRequired,
  fromSubscriptionIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.number.isRequired,
  isArchive: PropTypes.bool,
  licenses: PropTypes.arrayOf(licenseShape).isRequired,
  licensesToAssign: PropTypes.arrayOf(PropTypes.object).isRequired,
  needsConfiguration: PropTypes.bool.isRequired,
  nsCustomerId: PropTypes.string,
  nsSubscriptionId: PropTypes.string.isRequired,
  payerNetsuiteCustomer: PropTypes.object.isRequired,
  payerNetsuiteCustomerId: PropTypes.number,
  setUpAdminEmail: PropTypes.string.isRequired,
  skus: PropTypes.arrayOf(subscriptionSkuShape).isRequired,
  startDate: PropTypes.string.isRequired,
})



// WEBPACK FOOTER //
// ./src/lib/shapes.js